'use client';

/* empty css                                     */
/* empty css                                        */
/* empty css                                     */
/* empty css                                      */
/* empty css                                      */
/* empty css                                       */
/* empty css                                        */
/* empty css                                         */
/* empty css                                  */
var container = "c5-19-3_mmm1dv0 c5-19-3_nly6ul4";
var containerSize = { sm: "c5-19-3_mmm1dv1", md: "c5-19-3_mmm1dv2", lg: "c5-19-3_mmm1dv3" };
var spin = "c5-19-3_mmm1dv5";
export {
  container,
  containerSize,
  spin
};
